import { ReactNode } from 'react'

import { Icon } from 'components'

export interface NavItem {
  title: string
  path: string
  icon?: ReactNode
  subItems?: NavItem[]
  permission: string[]
}

export const sidebarData: NavItem[] = [
  {
    title: 'Gerenciar conta',
    path: '/profile',
    permission: [],
    icon: <Icon name="profile" width={20} color="element-default" />,
  },
  {
    title: 'Eventos',
    path: '/event/list',
    permission: [],
    icon: <Icon name="event" width={18} color="element-default" />,
  },
  {
    title: 'Contatos',
    path: '/contacts',
    permission: [],
    icon: <Icon name="contact-list" width={18} color="element-default" />,
  },
  {
    title: 'Zonas e equipamentos',
    path: '/zones',
    permission: [],
    icon: <Icon name="device" width={18} color="element-default" />,
  },
]
